import React from 'react';

interface BrowserMockupProps {
  src: string;
  alt: string;
  url?: string;
  placeholder?: string;
}

function BrowserMockup({ src, alt, url = 'app.example.com', placeholder }: BrowserMockupProps) {
  return (
    <div className="rounded-lg border border-line bg-canvas-muted overflow-hidden shadow-card">
      <div
        className="flex items-center gap-2 px-4 border-b border-line bg-surface"
        style={{ minHeight: '52px' }}
      >
        <div className="flex gap-1.5 flex-shrink-0">
          <span className="w-3 h-3 rounded-full bg-red-400/80" />
          <span className="w-3 h-3 rounded-full bg-amber-400/80" />
          <span className="w-3 h-3 rounded-full bg-emerald-400/80" />
        </div>
        <div className="flex-1 mx-2 min-w-0">
          <div className="text-[11px] text-ink-muted text-center truncate px-4 py-1.5 rounded-md bg-canvas-muted border border-line">
            {url}
          </div>
        </div>
      </div>
      {src ? (
        <img src={src} alt={alt} className="w-full h-full object-cover object-top min-h-[200px]" loading="lazy" />
      ) : (
        <div className="w-full min-h-[220px] sm:min-h-[280px] flex items-center justify-center bg-gradient-to-br from-canvas-muted to-canvas border-t border-line">
          <div className="text-center px-6">
            <p className="text-sm font-semibold text-ink mb-1">{placeholder || alt}</p>
            <p className="text-xs text-ink-muted">Screenshot coming soon</p>
          </div>
        </div>
      )}
    </div>
  );
}

export default BrowserMockup;
